import React from 'react';
import { formatMoney, MONEY_UNIT, formatInt } from '../utils/format';
import YoYBadge from './YoYBadge';
import KpiPanels from './KpiPanels';
import type { KpiPanel } from './KpiPanels';
import './su-components.css';

export interface KpiCardProps {
  title: string;
  /** Sales in rupees. */
  sales: number | null | undefined;
  lySales: number | null | undefined;
  yoyPct: number | null | undefined;
  storeCount?: number | null;
  /** Shown instead of values when the block is unavailable (e.g. LFL = null). */
  unavailable?: boolean;
  loading?: boolean;
  /** Two-period view; replaces the single value block. */
  panels?: KpiPanel[];
}

const KpiCard: React.FC<KpiCardProps> = ({ title, sales, lySales, yoyPct, storeCount, unavailable, loading, panels }) => (
  <div className="su-card su-kpi">
    <div className="su-kpi-title">
      <span>{title}</span>
      {!unavailable && storeCount != null && <span className="su-chip">{formatInt(storeCount)} stores</span>}
    </div>
    {unavailable ? (
      <div className="su-muted" style={{ padding: '12px 0' }}>LFL data coming soon</div>
    ) : loading && sales == null ? (
      <div className="su-skeleton" style={{ height: 34, width: '60%' }} />
    ) : panels ? (
      <KpiPanels panels={panels} />
    ) : (
      <>
        <div className="su-kpi-value su-num">
          {formatMoney(sales)}
          <span className="su-kpi-unit">{MONEY_UNIT.key}</span>
        </div>
        <div className="su-kpi-row">
          <span className="su-num">vs LY {formatMoney(lySales)} {MONEY_UNIT.key}</span>
          <YoYBadge value={yoyPct} variant="inline" />
        </div>
      </>
    )}
  </div>
);

export default KpiCard;
